import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { L10nConfig, L10nLoader, ProviderType, StorageStrategy, TranslationModule } from 'angular-l10n';
import { FileUploadModule } from 'ng2-file-upload';
import { AlgAttivazioniContractHeroComponent } from './components/alg-attivazioni/alg-attivazioni-contract-hero/alg-attivazioni-contract-hero.component';
import { AlgAttivazioniGeneralConditionComponent } from './components/alg-attivazioni/alg-attivazioni-general-condition/alg-attivazioni-general-condition.component';
import { AlgAttivazioniHeaderComponent } from './components/alg-attivazioni/alg-attivazioni-header/alg-attivazioni-header.component';
import { AlgAttivazioniInfoContractComponent } from './components/alg-attivazioni/alg-attivazioni-info-contract/alg-attivazioni-info-contract.component';
import { AlgAttivazioniInfoComponent } from './components/alg-attivazioni/alg-attivazioni-info/alg-attivazioni-info.component';
import { AlgAttivazioniLinearComponent } from './components/alg-attivazioni/alg-attivazioni-linear/alg-attivazioni-linear.component';
import { AlgAttivazioniLoaderComponent } from './components/alg-attivazioni/alg-attivazioni-loader/alg-attivazioni-loader.component';
import { AlgAttivazioniNextStepsComponent } from './components/alg-attivazioni/alg-attivazioni-next-steps/alg-attivazioni-next-steps.component';
import { AlgAttivazioniPersonalDataComponent } from './components/alg-attivazioni/alg-attivazioni-personal-data/alg-attivazioni-personal-data.component';
import { AlgAttivazioniRadioComponent } from './components/alg-attivazioni/alg-attivazioni-radio/alg-attivazioni-radio.component';
import { AlgAttivazioniStatusBarComponent } from './components/alg-attivazioni/alg-attivazioni-status-bar/alg-attivazioni-status-bar.component';
import { AlgAttivazioniStepLinearComponent } from './components/alg-attivazioni/alg-attivazioni-step-linear/alg-attivazioni-step-linear.component';
import { AlgAttivazioniStepComponent } from './components/alg-attivazioni/alg-attivazioni-step/alg-attivazioni-step.component';
import { AlgAttivazioniStep1Component } from './components/alg-attivazioni/alg-attivazioni-step1/alg-attivazioni-step1.component';
import { AlgAttivazioniStep2Component } from './components/alg-attivazioni/alg-attivazioni-step2/alg-attivazioni-step2.component';
import { AlgAttivazioniStep3Component } from './components/alg-attivazioni/alg-attivazioni-step3/alg-attivazioni-step3.component';
import { AlgAttivazioniStep4Component } from './components/alg-attivazioni/alg-attivazioni-step4/alg-attivazioni-step4.component';
import { AlgAttivazioniStepsComponent } from './components/alg-attivazioni/alg-attivazioni-steps/alg-attivazioni-steps.component';
import { Cad1Component } from './components/alg-attivazioni/forms/cad1/cad1.component';
import { Cad2Component } from './components/alg-attivazioni/forms/cad2/cad2.component';
import { Cad3Component } from './components/alg-attivazioni/forms/cad3/cad3.component';
import { Cad4Component } from './components/alg-attivazioni/forms/cad4/cad4.component';
import { Cad5Component } from './components/alg-attivazioni/forms/cad5/cad5.component';
import { Cad6Component } from './components/alg-attivazioni/forms/cad6/cad6.component';
import { Title1Component } from './components/alg-attivazioni/forms/title1/title1.component';
import { Title2Component } from './components/alg-attivazioni/forms/title2/title2.component';
import { Title3Component } from './components/alg-attivazioni/forms/title3/title3.component';
import { Title4Component } from './components/alg-attivazioni/forms/title4/title4.component';
import { AlgBillingFrequencyBodyComponent } from './components/alg-billing-frequency/alg-billing-frequency-body/alg-billing-frequency-body.component';
import { AlgBillingFrequencyContractHeroComponent } from './components/alg-billing-frequency/alg-billing-frequency-contract-hero/alg-billing-frequency-contract-hero.component';
import { AlgBillingFrequencyFooterComponent } from './components/alg-billing-frequency/alg-billing-frequency-footer/alg-billing-frequency-footer.component';
import { AlgBillingFrequencyInfoCustomerComponent } from './components/alg-billing-frequency/alg-billing-frequency-info-customer/alg-billing-frequency-info-customer.component';
import { AlgBillingFrequencyInfoSupplyComponent } from './components/alg-billing-frequency/alg-billing-frequency-info-supply/alg-billing-frequency-info-supply.component';
import { AlgBillingFrequencyStepsRecapComponent } from './components/alg-billing-frequency/alg-billing-frequency-steps-recap/alg-billing-frequency-steps-recap.component';
import { AlgChangePlanConditionsSubscriptionComponent } from './components/alg-change-plan/alg-change-plan-conditions-subscription/alg-change-plan-conditions-subscription.component';
import { AlgChangePlanContractHeroComponent } from './components/alg-change-plan/alg-change-plan-contract-hero/alg-change-plan-contract-hero.component';
import { AlgChangePlanCustomerSubscriptionComponent } from './components/alg-change-plan/alg-change-plan-customer-subscription/alg-change-plan-customer-subscription.component';
import { AlgChangePlanGeneralConditionComponent } from './components/alg-change-plan/alg-change-plan-general-condition/alg-change-plan-general-condition.component';
import { AlgChangePlanInfoContractComponent } from './components/alg-change-plan/alg-change-plan-info-contract/alg-change-plan-info-contract.component';
import { AlgChangePlanInfoCustomerComponent } from './components/alg-change-plan/alg-change-plan-info-customer/alg-change-plan-info-customer.component';
import { AlgChangePlanInfoSubscriptionComponent } from './components/alg-change-plan/alg-change-plan-info-subscription/alg-change-plan-info-subscription.component';
import { AlgEmailManagementContractHeroComponent } from './components/alg-email-management/alg-email-management-contract-hero/alg-email-management-contract-hero.component';
import { AlgEmailManagementCustomerInfoComponent } from './components/alg-email-management/alg-email-management-customer-info/alg-email-management-customer-info.component';
import { AlgEmailManagementInfoSubscriptionComponent } from './components/alg-email-management/alg-email-management-info-subscription/alg-email-management-info-subscription.component';
import { AlgPaymentConsentsComponent } from './components/alg-payment-method/alg-payment-consents/alg-payment-consents.component';
import { AlgSupplyInvoiceReceptionInfoSubscriptionComponent } from './components/alg-supply-invoice-reception-management/alg-supply-invoice-reception-info-subscription/alg-supply-invoice-reception-info-subscription.component';
import { AlgUploadDocumentComponent } from './components/alg-upload-document/alg-upload-document.component';
import { AlgAgileGeneralConditionComponent } from './components/molecules/alg-agile-general-condition/alg-agile-general-condition.component';
import { AlgAgileInfoContractComponent } from './components/molecules/alg-agile-info-contract/alg-agile-info-contract.component';
import { AlgAgileNextStepsComponent } from './components/molecules/alg-agile-next-steps/alg-agile-next-steps.component';
import { AlgConsensoContractHeroComponent } from './components/molecules/alg-consenso-contract-hero/alg-consenso-contract-hero.component';
import { AlgConsensoGeneralConditionComponent } from './components/molecules/alg-consenso-general-condition/alg-consenso-general-condition.component';
import { AlgConsensoInfoContractComponent } from './components/molecules/alg-consenso-info-contract/alg-consenso-info-contract.component';
import { AlgConsensoNextStepsComponent } from './components/molecules/alg-consenso-next-steps/alg-consenso-next-steps.component';
import { AlgConsensoPersonalDataComponent } from './components/molecules/alg-consenso-personal-data/alg-consenso-personal-data.component';
import { AlgConsensoUnipolPersonalDataComponent } from './components/molecules/alg-consenso-unipol-personal-data/alg-consenso-unipol-personal-data.component';
import { AlgFissoContractHeroComponent } from './components/molecules/alg-fisso-contract-hero/alg-fisso-contract-hero.component';
import { AlgFissoGeneralConditionComponent } from './components/molecules/alg-fisso-general-condition/alg-fisso-general-condition.component';
import { AlgFissoInfoContractComponent } from './components/molecules/alg-fisso-info-contract/alg-fisso-info-contract.component';
import { AlgLinearNextStepsComponent } from './components/molecules/alg-linear-next-steps/alg-linear-next-steps.component';
import { ConsensoRoutingModule, pageComponentsConsenso } from './consenso.route';
import { AlgAttivazioniComponent } from './pages/alg-attivazioni/alg-attivazioni.component';
import { AlgSwitchPageComponent } from './pages/alg-switch-page/alg-switch-page.component';
import { AlgAttivazioniService } from './services/alg-attivazioni.service';
import { AlgConsensoService } from './services/alg-consenso.service';
import { AlgFisicoService } from './services/alg-fisico.service';
import { AlgGtmService } from './services/alg-gtm.service';
import { AlgPrivacyService } from './services/alg-privacy.service';
import { AlgScontoService } from './services/alg-sconto.service';
import { ApiService } from './services/api.service';
import { UtilsService } from './services/utils.service';
import { SharedModule } from './shared.module';
const l10nConfig: L10nConfig = {
  locale: {
    languages: [{ code: 'it', dir: 'ltr' }],
    language: 'it',
    storage: StorageStrategy.Cookie,
  },
  translation: {
    providers: [
      {
        type: ProviderType.Static,
        prefix: './assets/locale-',
      },
    ],
    caching: true,
    missingValue: 'no key',
  },
};

@NgModule({
  imports: [CommonModule, ConsensoRoutingModule, SharedModule, FormsModule, ReactiveFormsModule, FileUploadModule, TranslationModule.forRoot(l10nConfig)],
  declarations: [
    ...pageComponentsConsenso,
    AlgAttivazioniComponent,
    AlgAttivazioniStep1Component,
    AlgAttivazioniHeaderComponent,
    AlgAttivazioniLinearComponent,
    AlgAttivazioniStepLinearComponent,
    AlgAttivazioniStepsComponent,
    AlgAttivazioniStep2Component,
    AlgAttivazioniStep3Component,
    AlgAttivazioniStepComponent,
    AlgAttivazioniInfoComponent,
    AlgAttivazioniStep4Component,
    AlgAttivazioniStatusBarComponent,
    AlgAttivazioniRadioComponent,
    AlgAttivazioniLoaderComponent,
    Title1Component,
    Title2Component,
    Title4Component,
    Title3Component,
    Cad1Component,
    Cad2Component,
    Cad3Component,
    Cad4Component,
    Cad5Component,
    Cad6Component,
    AlgAttivazioniContractHeroComponent,
    AlgAttivazioniInfoContractComponent,
    AlgAttivazioniPersonalDataComponent,
    AlgAttivazioniGeneralConditionComponent,
    AlgAttivazioniNextStepsComponent,
    AlgSwitchPageComponent,
    AlgConsensoGeneralConditionComponent,
    AlgConsensoContractHeroComponent,
    AlgConsensoInfoContractComponent,
    AlgConsensoPersonalDataComponent,
    AlgConsensoUnipolPersonalDataComponent,
    AlgConsensoNextStepsComponent,
    AlgLinearNextStepsComponent,
    AlgAgileNextStepsComponent,
    AlgAgileInfoContractComponent,
    AlgAgileGeneralConditionComponent,
    AlgFissoInfoContractComponent,
    AlgFissoGeneralConditionComponent,
    AlgFissoContractHeroComponent,
    AlgChangePlanContractHeroComponent,
    AlgChangePlanInfoContractComponent,
    AlgChangePlanGeneralConditionComponent,
    AlgChangePlanInfoCustomerComponent,
    AlgChangePlanCustomerSubscriptionComponent,
    AlgChangePlanConditionsSubscriptionComponent,
    AlgChangePlanInfoSubscriptionComponent,
    AlgUploadDocumentComponent,
    AlgBillingFrequencyContractHeroComponent,
    AlgBillingFrequencyFooterComponent,
    AlgBillingFrequencyBodyComponent,
    AlgBillingFrequencyInfoCustomerComponent,
    AlgBillingFrequencyInfoSupplyComponent,
    AlgBillingFrequencyStepsRecapComponent,
    AlgEmailManagementContractHeroComponent,
    AlgEmailManagementCustomerInfoComponent,
    AlgEmailManagementInfoSubscriptionComponent,
    AlgSupplyInvoiceReceptionInfoSubscriptionComponent,
    AlgPaymentConsentsComponent,
  ],
  providers: [ApiService, AlgGtmService, UtilsService, AlgFisicoService, AlgPrivacyService, AlgScontoService, AlgAttivazioniService, AlgConsensoService],
})
export class ConsensoModule {
  constructor(public l10nLoader: L10nLoader) {
    this.l10nLoader.load();
  }
}



// WEBPACK FOOTER //
// ./src/app/consenso.module.ts